export default __webpack_public_path__ + "static/media/logo.f197ae6e.png";